import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { IImpersonationContext } from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface IUpdateTagFavoriteParams {
	tagId: string;
	favoriteFor: Api.FavoriteFor;
}

interface IUpdateTagFavoriteOptions {
	impersonationContext?: IImpersonationContext;
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

export const useUpdateTagFavoriteMutation = ({
	impersonationContext,
	onSuccess,
	onError,
}: IUpdateTagFavoriteOptions = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ tagId, favoriteFor }: IUpdateTagFavoriteParams) => {
			return userSession.webServiceHelper.callAsync<Api.IBoard>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tag/${tagId}/favorite?favoriteFor=${favoriteFor}&expand=TagAlert`,
				}),
				'PUT',
				null
			);
		},
		onError,
		onSuccess,
	});
};
